import { type ReactNode } from "react";
import { CheckOutlined, CloseCircleFilled } from "@ant-design/icons";
import clsx from "clsx";
import type { JournalsAmendmentsStatus } from "@features/journal-version-list";
import "./journals-amendments-status-badge.scss";

export type { JournalsAmendmentsStatus };

interface JournalsAmendmentsStatusBadgeProps {
  status: JournalsAmendmentsStatus;
}

const STATUS_CONFIG: Record<
  JournalsAmendmentsStatus,
  { label: string; cls: string; icon?: ReactNode }
> = {
  PUBLISHED: {
    label: "Опубликовано",
    cls: "published",
    icon: <CheckOutlined />,
  },
  SIGNING_CHANGES: {
    label: "Подписание изменений",
    cls: "signing-changes",
  },
  PREPARING_XML: { label: "Подготовка XML", cls: "preparing-xml" },
  ON_SIGNING: { label: "На подписании", cls: "on-signing" },
  NEW: { label: "Новое", cls: "new" },
  REJECTED: {
    label: "Отклонено",
    cls: "rejected",
    icon: <CloseCircleFilled />,
  },
};

export const JournalsAmendmentsStatusBadge = ({
  status,
}: JournalsAmendmentsStatusBadgeProps) => {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.NEW;

  return (
    <span
      className={clsx(
        "journals-amendments-status-badge",
        `journals-amendments-status-badge--${cfg.cls}`,
      )}
    >
      {cfg.cls === "new" && (
        <span className="journals-amendments-status-badge__dot" aria-hidden />
      )}
      {cfg.icon}
      {cfg.label}
    </span>
  );
};
